/* eslint-disable */
// import $ from 'zepto';
// import seajs from 'seajs';
import { load } from '../ws-util';
import { browser, storage } from '../ws-hybrid';
import pageInfo from './pageInfo';

// 上报信息 START
let _cpAttachData;
let _cpActAttachData;

// dc02249向dc03092和dc03100的映射
const _tableDataMap = {
  dc03092: {
    is_visitor: 'is_reg',
    to_id: 'to_personid',
    reserves4: 'source',
    reserves3: 'log_sour',
    guid_real: 'guid',
    reserves5: 'h5_type',
    reserves6: 'page_type',
    reserves16: 'reserves5', // 表示一次分享还是二次分享
    gift_id: 'music_id',
    like_id: 'topicid',
    live_type: 'activity_id',
  },

  dc03100: {
    is_visitor: 'is_reg',
    to_id: 'to_uin',
    reserves4: 'reserves',
    reserves3: 'reserves1',
    reserves6: 'reserves4',
    reserves16: 'reserves16', // 表示一次分享还是二次分享
    guid_real: 'guid',
    reserves5: 'h5_type',
    gift_id: 'music_id',
    like_id: 'topicid',
    live_type: 'activity_id',
  },
};

/**
 * 后台authType定义： 1: QQ openid， 2： WTLOGIN QQ， 3： 微信openid
 * 上报userType定义： 1、 QQ 2、 微信 0、 游客
 */
const userTypeMap = {
  1: '1',
  2: '1',
  3: '2',
  others: '0',
};

// 见 http://tapd.oa.com/xinweishi/prong/stories/view_des/1010156291061964911
const pageMap = {
  others: 0,
  feed: 1,
  play: 1,
  topic: 2,
  music: 3,
  personal: 4,
  recommend: 5,
  // 6、运营活动页
  static: 7,
  hongbaofeed: 8,
  // 9、音乐全屏页
  acttogether: 10,
  geo: 11,
};

// 链接上的 attach 信息
function getAttachInfo() {
  if (_cpAttachData) return _cpAttachData;

  _cpAttachData = {};

  if (pageInfo.pageAttach) {
    const arr = pageInfo.pageAttach.split('|');
    for (let i = 0, len = arr.length; i < len; i += 1) {
      const tmp = arr[i].split('_');
      if (tmp.length == 3 && tmp[0] == 'cp' && /^\w+$/.test(tmp[1])) {
        // eslint-disable-next-line prefer-destructuring
        _cpAttachData[tmp[1]] = tmp[2];
      }
    }
  }

  return _cpAttachData;
}

// 链接上的 attach 信息
function getActAttachInfo() {
  if (_cpActAttachData) return _cpActAttachData;

  _cpActAttachData = {};

  if (pageInfo.pageAttach) {
    const arr = pageInfo.pageAttach.split('|');
    for (let i = 0, len = arr.length; i < len; i += 1) {
      const tmp = arr[i].split('_');
      if (tmp.length == 3 && tmp[0] == 'cpact' && /^\w+$/.test(tmp[1])) {
        // eslint-disable-next-line prefer-destructuring
        _cpActAttachData[tmp[1]] = tmp[2];
      }
    }
  }

  return _cpActAttachData;
}

// 客户端来源
function getSource(reserves) {
  const reserves3 = `${reserves || ''}`; // 保证是 string

  // 取 reserves3 首位当作客户端来源，如 3001 ，客户端来源 3 手Q
  // reserves3 是 5 位的话取前两位，如 10001
  const source = reserves3.replace(reserves3.slice(-3), '');
  const { client } = browser;
  const clientMap = {
    qzone: 1,
    qq: 2,
    // 2 结合版
    // 3 手Q
    wx: 4,
    // 5 看点
    kg: 6,
    others: 7,
    ws: 8,
    QQBrowser: 9,
    wb: 10,
  };

  return source || clientMap[client] || clientMap.others;
}

function getUserType(authType) {
  return userTypeMap[authType] || userTypeMap.others;
}

// 所以表都按照 dc02249 来转
function dataTableMap(table, data) {
  const result = {};
  const map = _tableDataMap[table];
  let mapKey = '';

  if (!map) return data;

  // eslint-disable-next-line guard-for-in
  for (const key in data) {
    mapKey = map[key] || key;
    result[mapKey] = result[mapKey] || data[key];
  }

  return result;
}
// 上报信息 END

// 设备信息 START
function getDeviceInfo() {
  // _deferDeviceInfo = $.Deferred();
  return new Promise((resolve) => {
    if (browser.client === 'qzone') {
      // eslint-disable-next-line no-unused-expressions
      window.mqq && window.mqq.invoke('device', 'getDeviceInfo', (data) => {
        console.log(`identifier ${data.data && data.data.identifier}`);
        resolve(data.data);
      });
    } else if (browser.client === 'qq') {
      // eslint-disable-next-line no-unused-expressions
      window.mqq && window.mqq.device.getDeviceInfo((data) => {
        console.log(`identifier ${data && data.identifier}`);
        resolve(data);
      });
    } else {
      resolve({});
    }
  });
}
// 设备信息 END


// 网络信息 START
function getNetworkInfo() {
  // _networkInfo = $.Deferred();
  return new Promise((resolve) => {
    if (browser.client === 'qzone') {
      // eslint-disable-next-line no-unused-expressions
      window.QZAppExternal && window.QZAppExternal && window.QZAppExternal.getConn((dataC) => {
        const data = dataC || {};
        if (data.code == 0) {
          data.data = data.data.toLowerCase();
          switch (data.data) {
            case 'wifi':
            case 'weakwifi':
            case 'strongwifi':
              data.type = 1;
              data.net = 'wifi';
              break;
            case '2g':
              data.type = 2;
              data.net = '2G';
              break;
            case '3g':
              data.type = 3;
              data.net = '3G';
              break;
            case '4g':
              data.type = 4;
              data.net = '4G';
              break;
            case '5g':
              data.type = 5;
              data.net = '5G';
              break;
            default:
              data.type = 9;
              data.net = 'unknow';
          }
        } else {
          data.type = 9;
          data.net = 'unknow';
        }

        console.log(`network ${JSON.stringify(data)}`);
        resolve(data);
      });
    } else if (browser.client === 'qq') {
      if (window.mqq) {
        window.mqq.device.getNetworkInfo((res) => {
          const result = res || {};

          switch (result.type) {
            case 1:
              result.net = 'wifi';
              break;
            case 2:
              result.net = '2G';
              break;
            case 3:
              result.net = '3G';
              break;
            case 4:
              result.net = '4G';
              break;
            case 5:
              result.net = '5G';
              break;
            default:
              result.type = 9;
              result.net = 'unknow';
          }

          console.log(`network ${JSON.stringify(result)}`);
          resolve(result);
        });
      }
    } else {
      resolve({
        type: 9,
        net: 'unknow',
      });
    }
  });
}
// 网络信息 END

// 防重点击
const voidClickParams = {};

function voidClick(key, time) {
  // true是可以点击
  if (voidClickParams[key]) {
    return false;
  }
  voidClickParams[key] = true;
  setTimeout(() => {
    voidClickParams[key] = false;
  }, time || 4000);

  return true;
}

function isValidPersonid(personid) {
  const tempPersonid = `${personid || ''}`;

  return tempPersonid.length === 16;
}

function initMoreBtn(cb) {
  window.mqq.invoke('ui', 'setTitleButtons', {
    right: {
      title: '更多',
      callback() {
        // 不敢兴趣
        cb();
      },
    },
  });
}

function initDisLikeBtn(feedIdFun, cb) {
  // 初始化右上角按钮逻辑
  if (!window.mqq) {
    return;
  }
  const feedId = feedIdFun();
  initMoreBtn(() => {
    // 弹出 ActionSheet
    window.mqq.invoke('ui', 'showActionSheet', {
      title: '操作',
      items: ['屏蔽 '],
      cancel: '取消',
      onclick: window.mqq.callback((type, index) => {
        console.log(type === 0 && index === 0, '======');
        if (type === 0 && index === 0) {
          if (cb) {
            cb(feedId);
          }
        }
      }),
    });
  });
}

/** Todo: should not use hasBindQRCodeEvent as a flag outside. */
let hasBindQRCodeEvent = false;

function showQRCode() {
  if (!hasBindQRCodeEvent) {
    hasBindQRCodeEvent = true;
    // $(window.parent.document).find('.j-icon-close').on('click', () => {
    //   $(window.parent.document).find('.j-pop').hide();
    // });
  }
  // $(window.parent.document).find('.j-pop').show();
}

let hasBindMaskCloseEvent = false;
function initSchemeTips(callBack) {
  // 对于一些无法跳转的客户端，给一个打开系统浏览器的提示浮层
  load.loadCss('//qzonestyle.gtimg.cn/qz-proj/weishi-mobile/mod-tip-mask.css', () => {
    if (document.querySelectorAll('.j-mod-tip-mask').length <= 0) {
      const html = `<div class="mod-tip-mask j-mod-tip-mask" style="display:none;">
                    <div class="arrow"></div>
                    <p class="tip">请点击右上角，选择“在${browser.platform === 'ios' ? 'Safari' : '浏览器'}中打开”</p>
                </div>`;
      document.body.append(html);
    }
    if (!hasBindMaskCloseEvent) {
      hasBindMaskCloseEvent = true;
      const tipMask = document.querySelector('.j-mod-tip-mask');
      if (tipMask) {
        tipMask.addEventListener('click', () => {
          tipMask.style.display = 'none';
        });
      }
    }

    if (callBack) {
      callBack();
    }
  });
  if (callBack) {
    callBack();
  }
}

function showSchemeTip(scheme) {
  window.location.hash = `#scheme=${encodeURIComponent(scheme)}`;
  initSchemeTips(() => {
    // $('.j-mod-tip-mask').show();
  });
}

function fixDefault(target, defaultValue) {
  const ret = {};
  for (const i in target) {
    if (!target[i] && target !== false && defaultValue[i]) {
      ret[i] = defaultValue[i];
    }
  }

  return ret;
}

function hasAuthData() {
  const authtype = parseInt(storage.cookie.get('iAuthType'));
  const openid = storage.cookie.get('openid');
  const openkey = storage.cookie.get('sSessionKey');
  const accessToken = storage.cookie.get('accessToken');
  const wxOpenId = storage.cookie.get('w_openid');
  const wxAccessToken = storage.cookie.get('w_AccessToken');
  let result = false;
  if (authtype === 3) {
    if (browser.client === 'ws') {
      result = openid && accessToken;
    } else {
      result = wxOpenId && wxAccessToken;
    }
  } else {
    result = authtype && openid && openkey;
  }

  return result;
}

function isInteractiveVideo(feed) {
  return !!(feed && feed.extern_info && feed.extern_info.interact_conf && feed.extern_info.interact_conf.token);
}

export default {
  pageMap,
  getAttachInfo,
  getActAttachInfo,
  getSource,
  getUserType,
  dataTableMap,
  getDeviceInfo,
  getNetworkInfo,
  // autoPlayInIOSWeiXin,
  voidClick,
  isValidPersonid,
  initDisLikeBtn,
  showQRCode,
  showSchemeTip,
  fixDefault,
  hasAuthData,
  isInteractiveVideo,
};
